import {
    addNewRowToTable,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoShowPrice,
    RaikoTableTitleContainer,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {Helmet} from "react-helmet";
import {RouteHelper, RouteInfo} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {FundService} from "../../serverService/fund/FundService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import AddNewFund from "./AddNewFund";
import {useNavigate} from "react-router-dom";

export default function FundList() {

    const service = new FundService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [page, setPage] = useState(1);
    const size = 25

    const [funds, setFunds] = useState([])
    const [totalItems, setTotalItems] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);

    const navigate = useNavigate()

    useEffect(() => {
        getFundsFromServer()
    }, [page]);

    function prepareFundsListItem(number, id, cashBalance, countOfGroup, countOfMember, enabled, name, postalAddress, totalBalance, totalLoanAmount) {
        return {
            number,
            findId: id,
            id,
            name,
            inventory: <RaikoShowPrice amount={cashBalance}/>,
            loan: <RaikoShowPrice amount={totalLoanAmount}/>,
            totalBalance: <RaikoShowPrice amount={totalBalance}/>,
            countOfGroup,
            countOfMember,
            address: postalAddress,
            status: <RaikoCustomSimpleActiveDeActiveChip
                state={enabled}
                deActiveStateTitle={"غیرفعال"}
                activeStateTitle={"فعال"}/>,
        };
    }

    function getFundsFromServer() {
        setTableLoading(true)
        service.getFundsList(
            page - 1,
            size
        ).then(response => {
            setFunds([])
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            response.data.map((item, index) => {
                setFunds(prev => [
                        ...prev,
                        prepareFundsListItem(
                            ((page - 1) * size) + index + 1,
                            item.id,
                            item.cashBalance,
                            item.countOfGroup,
                            item.countOfMember,
                            item.enabled,
                            item.name,
                            item.postalAddress,
                            item.totalBalance,
                            item.totalLoanAmount
                        )
                    ]
                )
            })
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    function handleChangePagination(newPage) {
        setPage(newPage + 1)
    }


    const [openAddNewItemDialog, setOpenAddNewItemDialog] = useState(false);
    const handleOpenDialog = () => setOpenAddNewItemDialog(true)
    const handleCloseDialog = () => setOpenAddNewItemDialog(false)

    function handleAddNewItemToTable(item) {
        const newItems = addNewRowToTable(
            prepareFundsListItem(
                ((page - 1) * size) + 1,
                item.id,
                0,
                0,
                0,
                item.enabled,
                item.name,
                item.postalAddress,
                0,
                0
            ),
            funds
        )

        setFunds(newItems)
        handleCloseDialog()
    }


    function handleSelectRow(_item) {
        let _title = ""
        funds.map((item) => {
            if (item.id === _item)
                _title = item.name
        })

        navigate(
            RouteHelper.FundDetail.globalUrl.replace(":id", _item),
            {state: {title: _title}, replace: false}
        )
    }

    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.FundsSuperAdmin.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openAddNewItemDialog}
                pageTitle={"افزودن صندوق جدید"}
                dialogSize={DialogSize.SMALL}
            >
                <AddNewFund handleAddNewItemToTable={handleAddNewItemToTable}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Funds.name,
                        ""
                    ),
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.FundsSuperAdmin.name,
                        RouteHelper.FundsList.url
                    )
                ]}/>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"صندوق ها"}
                            amount={totalItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                        />
                        <RaikoCustomTable
                            header={header}
                            data={funds}
                            isLoading={tableLoading}
                            newPage={page}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleSelectRow}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}

const header = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'findId',
        label: 'کد صندوق',
    },
    {
        id: 'name',
        label: 'نام صندوق',
    },
    {
        id: 'inventory',
        label: 'مجموع پس انداز (ریال)',
    },
    {
        id: 'loan',
        label: 'مجموع وام پرداختی (ریال)',
    },
    {
        id: 'totalBalance',
        label: 'موجودی کل (ریال)',
    },
    {
        id: 'countOfGroup',
        label: 'تعداد گروه ها',
    },
    {
        id: 'countOfMember',
        label: 'تعداد اعضا',
    },
    {
        id: 'address',
        label: 'آدرس',
    },
    {
        id: 'status',
        label: 'وضعیت',
    },
]